export class RestoreJobInitiationResponse {
    'jobId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return RestoreJobInitiationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
